import { MAIL, MESSAGE } from "../apiConstant";
import BaseApi from "../baseApi";

class MailApi extends BaseApi {
  getList(param) {
    return this.post(
      `${MESSAGE}/conversation/message/${param?.conversationId}`,
      param,
    );
  }

  sendMessage(request) {
    return this.post(`${MAIL}/send`, request);
  }

  sendFileChunk(request) {
    try {
      return this.post(`${MESSAGE}/send`, request);
    } catch (e) {
      console.error("Send message fail: " + e);
    }
  }

  shareMessage(request) {
    try {
      return this.post(`${MESSAGE}/share`, request);
    } catch (e) {
      console.error("Share message fail: " + e);
    }
  }

  cancelMessage(request) {
    try {
      return this.post(`${MESSAGE}/cancel`, request);
    } catch (e) {
      console.error("cancel message fail: " + e);
    }
  }

  removeMessage(request) {
    try {
      return this.post(`${MESSAGE}/remove`, request);
    } catch (e) {
      console.error("Remove message fail: " + e);
    }
  }

  reactionMessage(request) {
    try {
      return this.post(`${MESSAGE}/reaction`, request);
    } catch (e) {
      console.error("Reaction message fail: " + e);
    }
  }

  commentReply(request) {
    try {
      return this.post(`${MESSAGE}/comment`, request);
    } catch (e) {
      console.error("Comment message fail: " + e);
    }
  }

  deleteMessageNotifications(param) {
    return this.post(`${MAIL}/delete/${param?.conversationId}`);
  }

  uploadChunk(req) {
    return this.post(`${MESSAGE}/upload-chunk`, req);
  }

  mergeChunk(req) {
    return this.post(`${MESSAGE}/merge-chunk`, req);
  }
}

export default MailApi;
